export enum PermissionScopeTypes {
  League = "LEAGUES",
  Competition = "COMPETITIONS",
  Season = "SEASONS",
  EntityGroup = "ENTITYGROUPS",
  Entity = "ENTITIES",
}
